import type React from 'react';

import { useStepSixInfo } from '@/hooks/createSix/useStepSixInfo';
import StepSixInfoView from '@/components/organism/CreateSix/steps/StepSixInfo/StepSixInfo.view';
import {
  CREATE_SIX_DESCRIPTION_MAX_LENGTH,
  CREATE_SIX_NAME_MAX_LENGTH,
  MIN_LEN,
} from '@/constants';

export interface StepSixInfoProps {
  onClose: () => void;
}

export function StepSixInfo(props: StepSixInfoProps): React.JSX.Element {
  void props;

  const { state, handlers } = useStepSixInfo();

  const remainingNameCharacters = Math.max(CREATE_SIX_NAME_MAX_LENGTH - state.nameValue.length, MIN_LEN);
  const remainingDescriptionCharacters = Math.max(
    CREATE_SIX_DESCRIPTION_MAX_LENGTH - state.descriptionValue.length,
    MIN_LEN
  );
  const nameErrorMessage =
    state.nameValue.length > CREATE_SIX_NAME_MAX_LENGTH
      ? `SIX name must be ${CREATE_SIX_NAME_MAX_LENGTH} characters or fewer`
      : state.nameError;
  const descriptionErrorMessage =
    state.descriptionValue.length > CREATE_SIX_DESCRIPTION_MAX_LENGTH
      ? `Description must be ${CREATE_SIX_DESCRIPTION_MAX_LENGTH} characters or fewer`
      : state.descriptionError;
  const nameHasError = nameErrorMessage !== undefined && nameErrorMessage.length > MIN_LEN;
  const descriptionHasError =
    descriptionErrorMessage !== undefined && descriptionErrorMessage.length > MIN_LEN;

  return (
    <StepSixInfoView
      nameValue={state.nameValue}
      descriptionValue={state.descriptionValue}
      remainingNameCharacters={remainingNameCharacters}
      remainingDescriptionCharacters={remainingDescriptionCharacters}
      nameMaxLength={CREATE_SIX_NAME_MAX_LENGTH}
      descriptionMaxLength={CREATE_SIX_DESCRIPTION_MAX_LENGTH}
      nameHasError={nameHasError}
      nameErrorMessage={nameErrorMessage}
      descriptionHasError={descriptionHasError}
      descriptionErrorMessage={descriptionErrorMessage}
      onNameChange={handlers.handleNameChange}
      onDescriptionChange={handlers.handleDescriptionChange}
    />
  );
}

export default StepSixInfo;
